// extracted by mini-css-extract-plugin
export default {"component":"notFound__component___rgj1k"};